import { Helmet } from "react-helmet";

function getMetaFromSlug(slug = "") {
  switch (slug) {
    case "12 Grundprinzipien Animation":
      return {
        title: "12 Grundprinzipien der Animation",
        description: "Entdecke die 12 Grundprinzipien der Animation und wie sie deine Projekte zum Leben erwecken.",
        image: "https://www.denisbitter.de/images/blog/12prinzipien_sketch_m.png",
        url: `https://www.denisbitter.de/post/${slug}`,
        type: "BlogPosting",
      };

    case "kompass":
      return {
        title: "Kompass – Dein Weg zu klarem Lernen",
        description: "Persönliche Orientierung im digitalen Bildungsdschungel.",
        image: "https://www.denisbitter.de/images/kompass1.svg",
        url: `https://www.denisbitter.de/post/${slug}`,
        type: "BlogPosting",
      };
    default:
      return {
        title: "BITTER. LERN EINFACH.",
        description: "Digitale Bildung mit Haltung. Klar. Authentisch. Persönlich.",
        image: "https://www.denisbitter.de/images/default.jpg",
        url: `https://www.denisbitter.de/post/${slug}`,
        type: "WebPage",
      };
  }
}

export default function SeoHelmet({ slug }) {
  if (typeof window !== "undefined" && window.location.hostname === "localhost") return null;
  if (!slug) return null;

  const { title, description, url, image, type } = getMetaFromSlug(slug);

  const jsonLd = {
    "@context": "https://schema.org",
    "@type": type || "WebPage",
    "headline": title,
    "description": description,
    "image": image,
    "url": url,
    "datePublished": "2024-01-01", // optional: dynamisch erweitern
    "author": {
      "@type": "Person",
      "name": "Denis Bitter"
    },
    "publisher": {
      "@type": "Organization",
      "name": "BITTER. Lern Einfach",
      "logo": {
        "@type": "ImageObject",
        "url": "https://www.denisbitter.de/b_gray.png"
      }
    }
  };

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />

      {/* 🧠 STRUCTURED DATA */}
      <script type="application/ld+json">
        {JSON.stringify(jsonLd)}
      </script>
    </Helmet>
  );
}
